// Standalone MSAL singleton — extracted from index.tsx / auth.ts to break a
// circular import. Route loaders (React Router v7 data router) call into
// axios-client → auth.ts during `createBrowserRouter()` evaluation, which
// happens BEFORE index.tsx finishes binding its top-level `msalInstance`
// export. With the singleton living in its own leaf module, every consumer
// (index.tsx, auth.ts, axios-client.ts, AppProviders.tsx) sees a defined
// instance regardless of import-evaluation order.

import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser'

const tenantID: string = process.env.TENANT_ID as string
const applicationID: string = process.env.APP_ID as string
const redirectUri: string = `${window.location.origin}/tenants`
const signInAuthority = `https://login.microsoftonline.com/${tenantID}`

export const msalConfig: Configuration = {
  auth: {
    clientId: applicationID,
    authority: signInAuthority,
    redirectUri: redirectUri,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
        }
      },
    },
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)
